module.exports = __webpack_public_path__ + "static/media/zebra07.1312fb34.png";